import { Component, Input } from '@angular/core';
import { IonicModule, ModalController } from '@ionic/angular';
import { Order } from 'src/app/interfaces/order';
import { TicketInputComponent } from '../ticket-input/ticket-input.component';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ToastService } from 'src/app/services/toast.service';
import { OrderService } from 'src/app/services/order.service';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { registerLocaleData } from '@angular/common';
import localeDa from '@angular/common/locales/da';
import localeEu from '@angular/common/locales/eu';


@Component({
  selector: 'app-order-summary',
  templateUrl: './order-summary.component.html',
  styleUrls: ['./order-summary.component.scss'],
  standalone: true,
  imports: [
    IonicModule,
    TicketInputComponent,
    ReactiveFormsModule,
    DatePipe,
    CurrencyPipe,
  ]
})
export class OrderSummaryComponent {

  @Input() order: Order;
  @Input() showControls: boolean = false;

  public lang = 'da';
  public showBillingInfo: boolean = false;
  public isCancelling: boolean = false;

  public notRefundable: string[] = ['cancelled', 'refunded'];

  
  public cancelForm: FormGroup = new FormGroup({
    'confirm': new FormControl(false, Validators.requiredTrue)
  });


  constructor(
    private modalController: ModalController,
    private toast: ToastService,
    private orderService: OrderService
  ) {
    if (this.lang === 'da') {
      registerLocaleData(localeDa);
    } else {
      registerLocaleData(localeEu);
    }
  }


  /**
   * Cancels an existing order by order number
   * Makes a request to the order service to cancel the order
   * Shows success/error toast messages based on the response
   * Closes the modal on successful cancellation
   */
  public cancelOrder() {
    this.isCancelling = true;
    this.orderService.cancelOrder(this.order.order_number).subscribe({
      next: (response) => {
        if (response.success) {
          this.toast.presentToast('Ordren ' + this.order.order_number + ' blev annulleret', 'success');
          this.isCancelling = false;
          this.closeModal(true);
        } else {
          this.toast.presentToast('Der opstod en fejl under annullering af ordren', 'danger');
          this.isCancelling = false;
        }
      },
      error: (error) => {
        this.toast.presentToast('Der opstod en fejl: ' + error, 'danger');
        this.isCancelling = false;
      }
    });
  }


  /**
   * Closes the current modal and optionally triggers a refresh
   * @param refresh Optional boolean flag to indicate if data should be refreshed after closing
   */
  public closeModal(refresh: boolean = false) {
    this.modalController.dismiss({
      'dismissed': true,
      'refresh': refresh
    })
  }

}
